import { useQuery } from '@tanstack/react-query';
import { DocumentsService } from 'api';
import {
  FIRM_DOCUMENT_FILTER_OPTIONS_QUERY_KEY,
  FIRM_DOCUMENT_FILTER_OPTIONS_QUERY_STALE_TIME_MS,
} from './useFirmDocumentFilterOptionsQuery.constants';
import type { UseFirmDocumentFilterOptionsQueryParams } from './useFirmDocumentFilterOptionsQuery.types';
import { getNormalizedSearch } from '../documentsQuery.utils';

export const useFirmDocumentFilterOptionsQuery = ({
  companyId = null,
  enabled = true,
  firmId,
  firmLevel = false,
  fundId = null,
  measurementDateId = null,
  measurementDate = null,
  search,
}: UseFirmDocumentFilterOptionsQueryParams) => {
  const normalizedSearch = getNormalizedSearch(search);

  return useQuery({
    enabled: Boolean(firmId) && enabled,
    queryFn: () =>
      DocumentsService.apiDocumentsFirmsDocumentsFilterOptionsList(
        String(firmId),
        normalizedSearch,
        companyId ?? undefined,
        measurementDateId ?? undefined,
        measurementDate ?? undefined,
        fundId ?? undefined,
        firmLevel
      ),
    queryKey: [
      FIRM_DOCUMENT_FILTER_OPTIONS_QUERY_KEY,
      firmId,
      companyId ?? '',
      measurementDateId ?? '',
      measurementDate ?? '',
      fundId ?? '',
      normalizedSearch ?? '',
      firmLevel,
    ],
    staleTime: FIRM_DOCUMENT_FILTER_OPTIONS_QUERY_STALE_TIME_MS,
  });
};
